<div *ngIf="catalogs.length && market && lang">
  <ng-container *ngFor="let product of catalogs">
    <mat-tree [dataSource]="product" [treeControl]="treeControl" class="tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <mat-checkbox class="checkbox-auto-wrap" *ngIf="node.level !== 1" (change)="toggleProduct(node, product.data)"
                      [checked]="isProductSelected(node.key)">
          {{ node.externalId }} - {{ node.name[market][lang] }}
        </mat-checkbox>
        <span *ngIf="node.level === 1"
              class="space-h-xxl space-l-xxl">{{ node.name[market][lang] ? node.name[market][lang] : node.externalId }}</span>
        <span *ngIf=" !node.children?.length && node.level === 1" class="space-h-xxl space-l-xxl no-element-tree">
          {{ 'NO_ELEMENTS_TREE' | translate }}
        </span>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" [id]="'tree-' + node.key">
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <mat-checkbox class="checkbox-auto-wrap" *ngIf="node.level !== 1" (change)="toggleProduct(node, product.data)"
                        [checked]="isProductSelected(node.key)">
            {{ node.externalId }} - {{ node.name[market][lang] }}
          </mat-checkbox>
          <span
            *ngIf="node.level === 1">{{ node.name[market][lang] ? node.name[market][lang] : node.externalId }}</span>
        </div>
        <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>

    </mat-tree>
    <br/>
  </ng-container>

</div>
